import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PartnersWidget } from './partnerswidget';
import { SERVICES_DB } from '../data/service.data';

@Component({
    selector: 'membership-widget',
    standalone: true,
    imports: [CommonModule, RouterModule, PartnersWidget],
    template: `
        <section id="services" class="py-6 md:py-8 overflow-hidden">

            <div class="grid px-4 md:px-8 align-items-center mb-4">
                <div class="col-12 lg:col-6 pr-4">
                    <h2 class="font-heavy h2-mobile md:text-6xl mb-2 line-height-1">Nature &amp; Technology.</h2>
                    <h3 class="font-medium text-3xl md:text-5xl mb-4 md:line-height-2">
                        Encontrá la mejor solución <br> para vos, tu equipo o tu empresa, en nuestras Membresías.
                    </h3>
                    <p class="font-regular text-lg text-700 line-height-3 max-w-40rem">
                        Ya seas una empresa que está buscando un espacio permanente para su equipo,
                        una start-up con planes de crecimiento, o un freelancer que busca un escritorio individual,
                        elegí la membresía ideal para vos.
                    </p>
                </div>
                <div class="col-12 lg:col-6 text-center hidden lg:block relative">
                    <img src="/assets/img/home/handwriting_phrase.png"
                        alt="Enjoy the atmosphere"
                        class="w-full fadein-right mx-auto"
                        style="max-width: 33rem !important; transform: translateY(-1.2rem); position: relative; z-index: 10;"
                        />
                </div>
            </div>

            <partners-widget></partners-widget>

            <!-- DESKTOP: grid de cards (oculto en mobile) -->
            <div class="grid grid-nogutter px-6 mt-2 md:mt-0">
                <div *ngFor="let service of services" class="hidden md:block col-12 md:col-6 xl:col-3 p-3">
                    <div class="service-card h-full flex flex-column cursor-pointer border-round-3xl overflow-hidden relative transition-all duration-300"
                         [routerLink]="service.link">

                        <div class="h-15rem w-full overflow-hidden">
                            <img [src]="'/assets/img/home/' + service.img"
                                 [alt]="service.title"
                                 class="w-full h-full object-cover transition-transform duration-500" />
                        </div>

                        <div class="content bg-white p-4 flex flex-column flex-grow-1 border-round-bottom-3xl relative z-2">
                            <h3 class="font-heavy text-2xl text-900 mt-0 mb-2">
                                {{ service.title }}
                            </h3>
                            <p class="desc-text font-regular text-700 line-height-3 mb-4 flex-grow-1">
                                {{ service.desc }}
                            </p>
                            <div class="action-link font-bold text-lg text-900">
                                <span>{{ service.cta }}</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>

            <!-- MOBILE: accordion agrupado (oculto en md+) -->
            <div class="block md:hidden px-4 mt-2">
                <div *ngFor="let group of accordionGroups; let i = index">

                    <!-- Header -->
                    <button class="accordion-header" (click)="toggle(i, $event)">
                        <span>{{ group.label }}</span>
                    </button>

                    <!-- Panel: una o varias cards apiladas -->
                    <div class="accordion-panel w-10 mx-auto" [class.expanded]="openIndex === i">
                        <div class="accordion-panel-inner">
                            <div *ngFor="let service of group.items" class="accordion-card-wrap">
                                <div class="service-card accordion-card flex flex-row cursor-pointer border-round-3xl overflow-hidden relative transition-all duration-300"
                                     [routerLink]="service.link">

                                    <div class="accordion-image-wrap">
                                        <img [src]="'/assets/img/home/' + service.img"
                                             [alt]="service.title"
                                             class="transition-transform duration-500" />
                                    </div>

                                    <div class="content bg-white p-4 flex flex-column flex-grow-1 relative z-2">
                                        <h3 class="font-heavy text-2xl text-900 mt-0 mb-2">
                                            {{ service.title }}
                                        </h3>
                                        <p class="desc-text font-regular text-700 line-height-3 mb-4 flex-grow-1">
                                            {{ service.desc }}
                                        </p>
                                        <div class="action-link font-bold text-lg text-900">
                                            <span>{{ service.cta }}</span>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>

        </section>
    `,
    styles: [`
        /* Fuentes */
        .font-heavy  { font-family: "ABCDiatype-Heavy",   sans-serif; }
        .font-medium { font-family: "ABCDiatype-Medium",  sans-serif; }
        .font-regular{ font-family: "ABCDiatype-Regular", sans-serif; }


        /* Animación intro */
        .fadein-right { animation: fadeinright 1s ease-out; }
        @keyframes fadeinright {
            from { opacity: 0; transform: translateX(20px); }
            to   { opacity: 1; transform: translateX(0);    }
        }

        /* =============================================
           CARD (compartido desktop & accordion mobile)
           ============================================= */
        .service-card {
            border: 2px solid transparent;
            background-color: transparent;
        }
        .service-card:hover {
            transform: translateY(-5px);
            border-color: #00ff00;
            box-shadow:
                4px 4px 10px #00ff00,
                8px 8px 25px rgba(0, 255, 0, 0.9);
        }
        .service-card:hover img         { transform: scale(1.05); }
        .service-card:hover .content    { background-color: #000 !important; border-color: #000; }
        .service-card:hover h3          { color: #00ff00 !important; }
        .service-card:hover .desc-text,
        .service-card:hover .action-link{ color: #fff !important; }
        .service-card:hover i           { color: #00ff00 !important; }

        /* Estado permanente "hover" para cards dentro del accordion */
        .accordion-card {
            border-color: #00ff00;
            /* Más énfasis en borde inferior y derecho, glow amplio */
            box-shadow:
                4px 4px 10px #00ff00,
                8px 8px 25px rgba(0, 255, 0, 0.9);
        }
        .accordion-card .content    { background-color: #000 !important; border-color: #000; }
        .accordion-card h3          { color: #00ff00 !important; }
        .accordion-card .desc-text,
        .accordion-card .action-link{ color: #fff !important; }

        /* =============================================
           ACCORDION MOBILE
           ============================================= */
        .accordion-item {
            
        }

        .accordion-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            background: transparent;
            border: none;
            outline: none;
            font-family: "ABCDiatype-Medium", sans-serif;
            font-size: 2.5rem;
            color: #000;
            cursor: pointer;
            width: 100%;
            text-align: left;
            position: relative;
            transition: margin-bottom 0.3s ease;
        }

        .accordion-header span {
            position: relative;
        }

        /* Subrayado negro solo en el texto cuando el panel está abierto */
        .accordion-header span::after {
            content: '';
            position: absolute;
            bottom: 6px; 
            left: 0;
            width: 0;
            height: 2px;
            background: #000;
            transition: width 0.3s ease;
        }

        .accordion-header:has(+ .accordion-panel.expanded) {
            margin-bottom: 1rem;
        }

        .accordion-header:has(+ .accordion-panel.expanded) span::after {
            width: 100%;
        }

        /* Animación con grid-template-rows */
        .accordion-panel {
            display: grid;
            grid-template-rows: 0fr;
            transition: grid-template-rows 0.35s ease;
            /* overflow:hidden SIEMPRE: oculta el contenido cuando el track es 0fr */
            overflow: hidden;
        }
        .accordion-panel.expanded {
            grid-template-rows: 1fr;
            /* overflow:visible cuando está abierto: la sombra neon puede salir del borde del panel */
            overflow: visible;
        }
        .accordion-panel-inner {
            /* SIN padding: el inner debe colapsar a 0px real; cualquier padding
               rompe el grid-template-rows:0fr y genera los slivers visibles */
            min-height: 0;
            
        }
        /* El wrapper DENTRO del inner provee el espacio para que la sombra respire */
        .accordion-card-wrap {
            padding: 0.25rem 1rem 1.5rem 0.25rem;
        }

        /* Imagen en layout horizontal */
        .accordion-image-wrap {
            width: 120px;
            flex-shrink: 0;
            position: relative;
            min-height: 110px;
            overflow: hidden;
        }

        .accordion-image-wrap img {
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    `]
})
export class MembershipWidget {
    openIndex: number | null = null;

    toggle(index: number, event: MouseEvent): void {
        const isOpening = this.openIndex !== index;
        this.openIndex = isOpening ? index : null;

        if (isOpening) {
            const target = event.currentTarget as HTMLElement;
            setTimeout(() => {
                target.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }, 300);
        }
    }

    private mapService(slug: string) {
        const s = SERVICES_DB[slug];
        return {
            title: s.title,
            desc: s.shortDesc,
            img: s.image,
            link: `/service/${slug}`,
            cta: '+ info'
        };
    }

    // El desktop sigue usando una lista plana de 8 servicios
    services = [
        this.mapService('day-pass'),
        this.mapService('surf-desk'),
        this.mapService('full-flex'),
        this.mapService('fix'),
        this.mapService('private-office'),
        this.mapService('auditorio'),
        this.mapService('meeting-rooms'),
        this.mapService('hq')
    ];

    // MOBILE: "Flex" agrupa los primeros 3, el resto van solos
    accordionGroups = [
        {
            label: 'Flex',
            items: [
                this.mapService('day-pass'),
                this.mapService('surf-desk'),
                this.mapService('full-flex')
            ]
        },
        { label: 'Fix', items: [this.mapService('fix')] },
        { label: 'Private Office', items: [this.mapService('private-office')] },
        { label: 'Auditorio', items: [this.mapService('auditorio')] },
        { label: 'Meeting Rooms', items: [this.mapService('meeting-rooms')] },
        { label: 'HQ', items: [this.mapService('hq')] }
    ];
}